import React from 'react'
import { useNavigate } from 'react-router-dom'
import BackIco from '../assets/icons/back.png'
const Header = ({ label, right }) => {

    const navigation = useNavigate()

    return (
        <div
            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}

        >
            <img onClick={() => navigation(-1)} style={{ height: 25, width: 25, objectFit: 'contain' }} src={BackIco} />
            <h1 style={{ marginLeft: 25 }} >{label}</h1>
            <div style={{ flex: 1 }} />
            {right && right}

        </div>
    )
}

export default Header